module.exports = __webpack_public_path__ + "static/media/mcash.be635f22.png";